import { ChangeEvent } from 'react';
import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { MediaTypeBaseDataDto } from '@sr/dto';
import { useSnack } from 'shared/ui/snack';
import { useSetMediaTypeOrdReport } from './media-type.hooks';

type Props = {
  mediaType: MediaTypeBaseDataDto;
};

export const MediaTypeOrdReport = ({ mediaType }: Props) => {
  const { setOrdReport, isUpdating } = useSetMediaTypeOrdReport();

  const { showSuccess, showError } = useSnack();

  const handleChange = (e: ChangeEvent, checked: boolean) => {
    setOrdReport(mediaType, checked)
      .then(() => showSuccess(`Тип СМИ теперь ${checked ? 'участвует' : 'не участвует'} в отчете в ОРД`))
      .catch(e => showError('Ошибка изменения отчета в ОРД', e));
  };

  return (
    <Stack direction="column">
      <FormControlLabel
        disabled={isUpdating}
        control={
          <Switch checked={Boolean(mediaType.isOrdReport)} onChange={handleChange} />
        }
        label="Отчет в ОРД"
      />
      <Typography variant="body2" color="text.secondary">
        Счета с услугами этого типа СМИ автоматически получают флаг «Реклама в интернете»
      </Typography>
    </Stack>
  );
};
